<template>
  <div class="container">
    <el-button
      type="text"
      class="btn-wrapper"
      @click="emitTrainingTaskDialog"
    >
      <el-badge class="mark" :value="trainingTaskList.length">
        <i class="el-icon-loading"></i>
        训练队列
      </el-badge>
    </el-button>
    <el-dialog
      title="正在训练中的任务"
      :visible.sync="traingTaskShow"
      width="60%"
    >
      <el-table :data="trainingTaskList" style="width: 100%">
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="#"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="task_uuid"
          label="ID"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eatery_name"
          label="食堂"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="canteen_name"
          label="餐厅"
        >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="生成时间">
          <template slot-scope="scope">
            {{ scope.row.start_ts | tsToDate }}
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="viewUnderCanteen(scope.row)"
            >定位任务</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
  import {apiGetTrainTaskList} from '@/api';
  import {mapGetters} from 'vuex';

  export default {
  name: 'trainTaskListBtn',
  components: {},
  data () {
    return {
      trainingTaskList: [],
      traingTaskShow: false
    };
  },
  methods: {
    emitTrainingTaskDialog() {
      this.traingTaskShow = true;
      this.getTraingTask();
    },
    // 定位任务
    viewUnderCanteen(row) {
      let canteen = {
        canteen_name: row.canteen_name,
        canteen_id: Number(row.canteen_id)
      };
      let eatery = {
        eatery_name: row.eatery_name,
        eatery_id: Number(row.eatery_id)
      };
      let listQuery = this.listQuery;
      listQuery.canteen = canteen;
      listQuery.eatery = eatery;
      this.setListQuery(listQuery);
      this.setCanteenList({ isSearch: true });
      this.traingTaskShow = false;
      this.serverPointDialogShow = false;
      this.$router.push("trainTask");
    },
    async getTraingTask() {
      try {
        let res = await apiGetTrainTaskList(this.userinfo.api_key);
        this.trainingTaskList = res.training_task_list;
      } catch (e) {
        console.log(e);
        this.$message.error("获取正在运行的训练任务失败" + e.message);
      }
    }
  },
  computed: {
    ...mapGetters([
      'userinfo',
      'listQuery'
    ])
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
  .container {
    display: inline-block;
  }
</style>
